// import axios from 'axios';
import api from '@/assets/js/api'
import { cookie, queryString } from '@/assets/js/utils'


var shareObj = {
    title: "",
    timeline: '',
    desc: "",
    link: '',
    imgUrl: "https://act.odmkf.com/zhongyin/sdcj2022-ui/img/share.jpg?v2",
    success: function() {},
    cancel: function() {}
};
async function share(params = {}){
    shareObj = Object.assign({}, shareObj, params);

    let res = await api('get', '/jsSign', {
        url: location.origin + location.pathname,
    }).catch(err => {
        // console.log(err)
    })
    let { data, status } = res;
    // console.log(data, code ,msg)
    // hasReward
    if (status == 200) {

        let config = {
            // debug: false,
            // appId: data.appId,
            // timestamp: data.timestamp,
            // nonceStr: data.nonceStr,
            // signature: data.signature,
            // jsApiList: [
            //     "checkJsApi",
            //     "onMenuShareTimeline",
            //     "onMenuShareAppMessage",
            //     "onMenuShareQQ"
            // ]
            ...data
        }
        wx.config(config);

        wx.ready(function() {
            wx.onMenuShareTimeline(shareObj);
            wx.onMenuShareAppMessage(shareObj);
            wx.onMenuShareQQ(shareObj);
        });

        wx.error(res => {
            console.error("[wechat] error", res);
        });
    }

    
}

export default {
    share
}